import { Box, Card, Chip, IconButton, Tooltip } from "@mui/material";
import StatusChangeItem from "../../../components/common/StatusChangeItem";
import localize from "../../../common/localize";
import {
  Delete,
  Edit,
  Description,
  DesktopWindows,
} from "@mui/icons-material";

export default function StatusChangeConfigInfo({
  statusChangeObj,
  onEditButtonClick,
  onDeleteButtonclick,
  hideDeleteButton,
}) {
  const hasForm = !!statusChangeObj.DynamicForm;

  return (
    <Card
      variant="outlined"
      sx={{
        position: "relative",
        borderRadius: 2,
        overflow: "hidden",
        transition: "box-shadow 0.2s ease, transform 0.15s ease",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
          transform: "translateY(-1px)",
        },
        "&:hover .actions-panel": {
          opacity: 1,
          pointerEvents: "auto",
        },
      }}
    >
      {statusChangeObj.IsAdministrative && (
        <Box sx={{ px: 2, pt: 1.5 }}>
          <Chip
            icon={<DesktopWindows sx={{ fontSize: 14, color: "white !important" }} />}
            size="small"
            label={localize.only_web}
            sx={{
              fontWeight: 500,
              fontSize: "0.75rem",
              backgroundColor: "#10366E",
              color: "white",
            }}
          />
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          py: 1.5,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <StatusChangeItem
            initialStatus={statusChangeObj.InitialStatus}
            finalStatus={statusChangeObj.FinalStatus}
          />
        </Box>
      </Box>

      {statusChangeObj.FinalStatus && hasForm && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1,
            px: 2,
            pb: 1.5,
            borderTop: "1px solid",
            borderColor: "divider",
            pt: 1.5,
          }}
        >
          <Chip
            icon={<Description sx={{ fontSize: 14 }} />}
            size="small"
            variant="filled"
            color="warning"
            label={`${localize.form}: ${statusChangeObj.DynamicForm.Name}`}
            sx={{ fontWeight: 500, fontSize: "0.75rem", bgcolor: "#fff", color: "#000", "& .MuiChip-icon": { color: "#000" } }}
          />
        </Box>
      )}

      {statusChangeObj.FinalStatus && (
        <Box
          className="actions-panel"
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.5,
            px: 1,
            bgcolor: "primary.main",
            borderRadius: "0 8px 8px 0",
            opacity: 0,
            pointerEvents: "none",
            transition: "opacity 0.25s ease, transform 0.25s ease",
          }}
        >
          <Tooltip title={localize.edit} arrow placement="left">
            <IconButton
              size="small"
              onClick={onEditButtonClick}
              sx={{
                color: "white",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
              }}
            >
              <Edit sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
          {!hideDeleteButton && (
            <Tooltip title={localize.delete} arrow placement="left">
              <IconButton
                size="small"
                onClick={onDeleteButtonclick}
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
                }}
              >
                <Delete sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      )}
    </Card>
  );
}
